export default "__VITE_ASSET__3791684b__"